import { Text, View, StyleSheet } from "@react-pdf/renderer";

import { formateISODateToDateTime, getFullName } from "@/utils";

const Footer = ({ createdDate, author }) => {
  const styles = StyleSheet.create({
    footer: {
      padding: "30px 55px 50px",
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
    },
    footerInner: {
      paddingTop: 12,
      borderTop: "1px solid #BBBBBB",
      flexDirection: "row",
      gap: 10,
    },
    date: {
      width: 133,
    },
    author: {
      flexGrow: 1,
    },
    pages: {
      width: 53,
    },
    title: {
      color: "#bbb",
      marginBottom: 3,
    },
  });

  return (
    <View style={styles.footer} fixed>
      <View style={styles.footerInner}>
        <View style={styles.date}>
          <Text style={styles.title}>Дата создания паспорта:</Text>
          <Text>{formateISODateToDateTime(createdDate)}</Text>
        </View>
        <View style={styles.author}>
          <Text style={styles.title}>Распечатал:</Text>
          <Text>
            {getFullName(author.lastname, author.firstname, author.patronymic)}
          </Text>
        </View>
        <View style={styles.pages}>
          <Text style={styles.title}>Страницы:</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} из ${totalPages}`
            }
          />
        </View>
      </View>
    </View>
  );
};

export default Footer;
